import * as type from '../types';

// GET NOTIFICATION SETTINGS
export const getNotificationSettingsRequest = organizationId => ({
    type: type.GET_NOTIFICATION_SETTINGS_REQUEST,
    payload: organizationId
})

export const getNotificationSettingsSucceeded = data => ({
    type: type.GET_NOTIFICATION_SETTINGS_SUCCEEDED,
    payload: data
})

export const getNotificationSettingsFailed = () => ({
    type: type.GET_NOTIFICATION_SETTINGS_FAILED
})

// GET MENU NOTIFICATIONS
export const getMenuNotificationsRequest = organizationId => ({
    type: type.GET_MENU_NOTIFICATIONS_REQUEST,
    payload: organizationId
})

export const getMenuNotificationsSucceeded = data => ({
    type: type.GET_MENU_NOTIFICATIONS_SUCCEEDED,
    payload: data
})

export const getMenuNotificationsFailed = () => ({
    type: type.GET_MENU_NOTIFICATIONS_FAILED
})

// GET NOTIFICATIONS
export const getNotificationsRequest = reqParams => ({
    type: type.GET_NOTIFICATIONS_REQUEST,
    payload: reqParams
})

export const getNotificationsSucceeded = data => ({
    type: type.GET_NOTIFICATIONS_SUCCEEDED,
    payload: data
})

export const getNotificationsFailed = () => ({
    type: type.GET_NOTIFICATIONS_FAILED
})